export const TOKEN_KEY = 'token';
export const IMPERSONATING_KEY = 'impersonating';
export const CLIENT_ID_QUERY_KEY = 'client_id';
export const DRAFT_LOCK_QUERY_KEY = 'draft_locked';
export const AIR_REQUEST_MODAL_OPEN_QUERY_KEY = 'air_request_modal_open';
export const ALLOWED_EXTENSIONS = ['png', 'jpg', 'jpeg', 'pdf', 'heic'];
export const ALLOWED_EXTENSIONS_STRING = ALLOWED_EXTENSIONS.map((ext) => `.${ext}`).join(',');
export const ALLOWED_FILES_COUNT = 10;
export const MAX_FILE_SIZE_MB = 50;
export const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;
export const MAX_TOTAL_SIZE = MAX_FILE_SIZE;
export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const USER_CACHE_KEY = 'user';
export const SIDEBAR_FULL_SCREEN_WIDTH = 264;
export const SIDEBAR_SMALL_SCREEN_WIDTH = 72;